import * as actionTypes from '../actions';


const initialState = {
    emailsLeft: 0,
    emailsUsed: 0,
    emailsMax: 0,

    getEmailsLeftLoading: false,
    getEmailsLeftError: null,

    sendEmailLoading: false,
    sendEmailError: null,

    addMarketingImageLoading: false,
    addMarketingImageError: null,
};

const marketingReducer = (state = initialState, action) => {
    switch (action.type) {

        // GET EMAILS LEFT
        case actionTypes.GET_EMAILS_LEFT_REQUEST:
            return {
                ...state,
                getEmailsLeftLoading: action.loading
            };
        case actionTypes.GET_EMAILS_LEFT_SUCCESS:
            return {
                ...state,
                getEmailsLeftLoading: action.loading,
                getEmailsLeftError: action.error,
                emailsLeft: action.emailsLeft,
                emailsUsed: action.emailsUsed,
                emailsMax: action.emailsMax
            };
        case actionTypes.GET_EMAILS_LEFT_ERROR:
            return {
                ...state,
                getEmailsLeftLoading: action.loading,
                getEmailsLeftError: action.error
            };

        // SEND EMAIL
        case actionTypes.SEND_EMAIL_REQUEST:
            return {
                ...state,
                sendEmailLoading: action.loading
            };
        case actionTypes.SEND_EMAIL_SUCCESS:
            return {
                ...state,
                sendEmailLoading: action.loading,
                sendEmailError: action.error
            };
        case actionTypes.SEND_EMAIL_ERROR:
            return {
                ...state,
                sendEmailLoading: action.loading,
                sendEmailError: action.error
            };

        // ADD MARKETING IMAGE
        case actionTypes.ADD_MARKETING_IMAGE_REQUEST:
            return {
                ...state,
                addMarketingImageLoading: action.loading
            };
        case actionTypes.ADD_MARKETING_IMAGE_SUCCESS:
            return {
                ...state,
                addMarketingImageLoading: action.loading,
                addMarketingImageError: action.error
            };
        case actionTypes.ADD_MARKETING_IMAGE_ERROR:
            return {
                ...state,
                addMarketingImageLoading: action.loading,
                addMarketingImageError: action.error
            };

        default:
            return state;
    }
};

export default marketingReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/marketing.js